import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import IconButton from '@mui/material/IconButton'
import { useNavigate, useLocation } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import { useSidebar } from '../../context/SidebarContext'
import { brand } from '../../brand'

const navItems = [
  { label: 'Getting Started', path: '/getting-started' },
  { label: 'Guides', path: '/guides' },
  { label: 'Widgets', path: '/widgets' },
  { label: 'API Reference', path: '/api-reference' },
  { label: 'Testing', path: '/testing' },
  { label: 'Support', path: '/support' },
]

export default function Header() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isOpen, toggle } = useSidebar()

  const isActive = (path: string) => location.pathname.startsWith(path)

  return (
    <AppBar position="sticky" elevation={0}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton
            onClick={toggle}
            size="small"
            sx={{
              color: 'text.secondary',
              '&:hover': { bgcolor: 'grey.100' },
            }}
          >
            {isOpen ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
            onClick={() => navigate('/')}
          >
            <Typography
              variant="h6"
              sx={{
                color: 'text.primary',
                fontWeight: 700,
                letterSpacing: '-0.01em',
              }}
            >
              {brand.name}
            </Typography>
            <Chip
              label={brand.tagline}
              size="small"
              sx={{
                bgcolor: 'primary.main',
                color: 'white',
                fontWeight: 600,
                fontSize: '0.7rem',
                height: 22,
                display: { xs: 'none', sm: 'flex' },
              }}
            />
          </Box>
        </Box>

        <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 0.5 }}>
          {navItems.map((item) => (
            <Button
              key={item.path}
              onClick={() => navigate(item.path)}
              sx={{
                color: isActive(item.path) ? 'primary.main' : 'text.secondary',
                fontWeight: isActive(item.path) ? 600 : 500,
                fontSize: '0.875rem',
                px: 1.5,
                '&:hover': {
                  backgroundColor: 'grey.100',
                  color: 'primary.main',
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Chip
            label="v1.0"
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.75rem', display: { xs: 'none', sm: 'flex' } }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  )
}
